import { render, staticRenderFns } from "./djflist.vue?vue&type=template&id=10bd1f2b&scoped=true&"
import script from "./djflist.vue?vue&type=script&lang=js&"
export * from "./djflist.vue?vue&type=script&lang=js&"
import style0 from "./djflist.vue?vue&type=style&index=0&id=10bd1f2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bd1f2b",
  null
  
)

export default component.exports